// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
import ___CSS_LOADER_URL_IMPORT_0___ from "../../../../assets/images/topbar_bcg.svg";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1tUfWoeMIB5uWhL1eYM5dv{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-repeat:no-repeat;background-size:cover;background-position:center;background-color:#f5c531;height:8.64286rem;display:flex;align-items:center;justify-content:center;padding-bottom:2.5rem}._2Y4K4bojsSaTMagfME1Ec{width:12.28571rem}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topBar": "_1tUfWoeMIB5uWhL1eYM5dv",
	"topBar__image": "_2Y4K4bojsSaTMagfME1Ec"
};
export default ___CSS_LOADER_EXPORT___;
